import moment from "moment";

export const isNew = (createdDate) => {
    const createdMoment = moment.utc(createdDate);
    return moment().diff(createdMoment, 'days') <= 5;
}

export const eventDurationString = (startDate, endDate, longName = false, fullYear = false) => {
    const startMoment = moment(startDate).utc();
    const endMoment = moment(endDate).utc();
    const currentMoment = moment();
    const monthFormat = longName ? 'MMMM' : 'MMM';
    const fullYearFormat = `${fullYear ? ', YYYY' : ''}`;

    // if (fullYear) {
    //     return `${startMoment.format('MMMM DD, YYYY')} - ${endMoment.format('MMMM DD, YYYY')}`
    // }

    if (!startMoment.isSame(endMoment, "year")) {
        /**
         * Event spans multiple years
         */
        return `${startMoment.format("ll")}-${endMoment.format("ll")}`
    } else if (startMoment.isSame(endMoment, "day") && startMoment.isSame(currentMoment, "year")) {
        /**
         * One day event, current year
         */
        return startMoment.format(monthFormat + " D" + fullYearFormat);

    } else if (startMoment.isSame(endMoment, "day")) {
        /**
         * One day event, NOT current year
         */
        return startMoment.format(monthFormat + " D, YYYY");
    } else if (!startMoment.isSame(endMoment, "month") && startMoment.isSame(currentMoment, "year")) {
        /**
         * Event spans multiple months, current year
         */
        return `${startMoment.format(monthFormat + " D")}-${endMoment.format(
            monthFormat + " D" + fullYearFormat
        )}`;
    } else if (!startMoment.isSame(endMoment, "month")) {
        /**
         * Event spans multiple months, NOT current year
         */
        return `${startMoment.format(monthFormat + " D")}-${endMoment.format(
            monthFormat + " D, YYYY"
        )}`;
    } else if (!startMoment.isSame(currentMoment, "year")) {
        /**
         * Same month, not current year
         */
        return `${startMoment.format(monthFormat + " D")}-${endMoment.format(
            "D, YYYY"
        )}`;
    }

    return `${startMoment.format(monthFormat + " D")}-${endMoment.format(
        "D" + fullYearFormat
    )}`;
}